var truncateTextFromMiddle = function truncateTextFromMiddle(textToTrim, maxLength) {
  var ellipsis = "...";
  var halfMaxLength = Math.floor((maxLength - ellipsis.length) / 2);
  // checks to avoid invalid text trim
  // in case of 3 ellipsis, min text length should be 5 for the functionality to work properly
  if (textToTrim.length <= maxLength || maxLength <= ellipsis.length || !maxLength || halfMaxLength === 0) {
    return textToTrim;
  }
  var firstHalf = textToTrim.slice(0, halfMaxLength);
  var secondHalf = textToTrim.slice(-halfMaxLength);
  return "".concat(firstHalf).concat(ellipsis).concat(secondHalf);
};
var isEnterOrSpacePressed = function isEnterOrSpacePressed(event) {
  var checkEscape = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (event.key === "Enter" || event.key === " " || checkEscape && event.key === "Escape") {
    event.preventDefault();
    return true;
  }
  return false;
};
var copyTextToClipboard = function copyTextToClipboard(textToCopy) {
  var textarea = document.createElement("textarea");
  textarea.value = textToCopy;

  // Make the textarea hidden
  textarea.style.position = "absolute";
  textarea.style.left = "-9999px";

  // Add the textarea to the document
  document.body.appendChild(textarea);

  // Select the text in the textarea
  textarea.select();

  // Copy the selected text to the clipboard
  document.execCommand("copy");

  // Remove the textarea from the document
  document.body.removeChild(textarea);
};
var focusTabOnArrow = function focusTabOnArrow(event) {
  var orientation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "horizontal";
  var tabRef = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var index = arguments.length > 3 ? arguments[3] : undefined;
  var lastIndex = arguments.length > 4 ? arguments[4] : undefined;
  var getPrevIndex = function getPrevIndex(currentIndex, lastIndex) {
    return currentIndex === 0 ? lastIndex : currentIndex - 1;
  };
  var getNextIndex = function getNextIndex(currentIndex, lastIndex) {
    return currentIndex === lastIndex ? 0 : currentIndex + 1;
  };
  var arrowKeyMap = {
    horizontal: {
      prev: "ArrowLeft",
      next: "ArrowRight"
    },
    vertical: {
      prev: "ArrowUp",
      next: "ArrowDown"
    }
  };
  var arrowKeys = arrowKeyMap[orientation] || arrowKeyMap.horizontal;
  if ((event === null || event === void 0 ? void 0 : event.key) === arrowKeys.prev) {
    tabRef.current[getPrevIndex(index, lastIndex)].focus();
  } else if ((event === null || event === void 0 ? void 0 : event.key) === arrowKeys.next) {
    tabRef.current[getNextIndex(index, lastIndex)].focus();
  }
};

/**
 * Adds ARIA properties on elements that are in the background whenever
 * a modal is opened.
 * @param {bool} isAccessible Whether elements are accessible.
 */
function addAriaPropertiesOnBackgroundEls() {
  var isAccessible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var ignoreElement = arguments.length > 1 ? arguments[1] : undefined;
  var bodyEl = document.getElementsByTagName("body")[0];
  var excludedTags = ["script", "noscript", "style"];
  var excludedClasses = "lt-modal-wrapper";
  Array.from(bodyEl.children).forEach(function (el) {
    if (!excludedTags.includes(el.tagName.toLowerCase()) && !el.classList.contains(excludedClasses) && el.contains(ignoreElement) === false) {
      if (isAccessible) {
        el.removeAttribute("inert");
      } else {
        el.setAttribute("inert", true);
      }
    }
  });
}
var padWithZero = function padWithZero(number) {
  if (number === 0) {
    return number;
  }
  return number === null || number === void 0 ? void 0 : number.toString().padStart(2, "0");
};
var uniqueIdCounter = 0;
/**
 * Creates a unique ID with a prefix.
 * @param {string} prefix The prefix for the unique ID.
 * @returns {string} The unique ID.
 
 */
var createUniqueID = function createUniqueID() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return prefix + Math.random().toString(36).substr(2, 9) + uniqueIdCounter++;
};
var convertMsToMinutesAndSeconds = function convertMsToMinutesAndSeconds(milliseconds) {
  // Convert milliseconds to seconds
  var totalSeconds = milliseconds / 1000;

  // Calculate minutes
  var minutes = Math.floor(totalSeconds / 60);

  // Calculate remaining seconds
  var seconds = Math.floor(totalSeconds % 60);
  return {
    initMinute: minutes,
    initSeconds: seconds
  };
};

export { addAriaPropertiesOnBackgroundEls, convertMsToMinutesAndSeconds, copyTextToClipboard, createUniqueID, focusTabOnArrow, isEnterOrSpacePressed, padWithZero, truncateTextFromMiddle };
